import { FC, useRef, useState, useEffect } from 'react';
import { Editor } from '@tinymce/tinymce-react';

interface IEditorComponent {
	editorValue: any;
	editorOnchange: Function;
}
const EditorComponent: FC<IEditorComponent> = ({
	editorValue,
	editorOnchange,
}) => {
	const editorRef = useRef<any>(null);
	const [isEditorActive, setIsEditorActive] = useState(true);

	useEffect(() => {
		setIsEditorActive(false);

		// Check if TinyMCE is loaded and an editor is active
		// if (typeof tinymce !== 'undefined' && tinymce.activeEditor) {
		// 	setIsTinyMCEActive(true);
		// } else {
		// 	setIsTinyMCEActive(false);
		// }
	}, []);

	// console.log('');

	return (
		<div>
			{isEditorActive ? (
				<Editor
					// eslint-disable-next-line no-return-assign
					onInit={(evt: any, editor: any) => (editorRef.current = editor)}
					// initialValue={newsletter?.content}
					value={editorValue}
					init={{
						height: 500,
						max_width: 300,
						branding: false,
						overflow: 'auto',
						menubar: true,
						menu: {
							file: {
								title: 'File',
								items: 'newdocument restoredraft | preview | print ',
							},
							edit: {
								title: 'Edit',
								items: 'undo redo | cut copy paste | selectall | searchreplace',
							},
							view: {
								title: 'View',
								items:
									'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen',
							},
							insert: {
								title: 'Insert',
								items:
									'image link media template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor toc | insertdatetime',
							},
							format: {
								title: 'Format',
								items:
									'bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align lineheight | forecolor backcolor | removeformat',
							},
							tools: {
								title: 'Tools',
								items: 'spellchecker spellcheckerlanguage | code wordcount',
							},
							table: {
								title: 'Table',
								items: 'inserttable | cell row column | tableprops deletetable',
							},
							help: { title: 'Help', items: 'help' },
						},
						plugins: [
							'advlist autolink lists link image charmap print preview anchor',
							'searchreplace visualblocks code fullscreen',
							'insertdatetime media table paste code help wordcount',
							// 'lineheight',
						],
						toolbar:
							'formatselect |' +
							'bold italic backcolor | alignleft aligncenter ' +
							'alignright alignjustify | bullist numlist outdent indent |' +
							'removeformat | help',
						content_style:
							'body { font-family:Helvetica,Arial,sans-serif; font-size:14px; overflow-wrap: break-word }',
					}}
					onEditorChange={(newText) => editorOnchange(newText)}
				/>
			) : (
				<textarea
					value={editorValue}
					onChange={(e) => editorOnchange(e?.target?.value)}
					style={{ minHeight: '300px', width: '100%', padding: '10px' }}
				/>
			)}
		</div>
	);
};
export default EditorComponent;
